import requestor from "requestor";
import basePath from "base_path";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import ActionTypes from "../constants/action_types";

/* eslint-disable max-params */
export default createReduxPromiseAction(
  ActionTypes.DOCUMENT_CLAUSEPART_DELETIONS_REVERT,
  (
    organisationId,
    projectId,
    documentId,
    sectionId,
    clauseId,
    clausepartIds,
    headingData,
  ) =>
    requestor
      .post(
        `${basePath}/organisation/${organisationId}/project/${projectId}` +
          `/document/${documentId}/section/${sectionId}/clause/${clauseId}` +
          "/revert-clausepart-deletions",
        {
          ids: clausepartIds,
          ...(headingData && {
            heading_id: headingData.id,
            heading_last_edited: headingData.last_edited,
          }),
        },
        {withCredentials: true},
      )
      .then(response => response.data),
);
